import { useDispatch } from 'react-redux'
import { changePaidBookingField } from 'publisher/actions/optInActions'
import { optInSelectors, useTypedSelector } from 'publisher/store'
import { BookingFieldsSlug } from 'publisher/store/optIn/optInStateInterface'

export const usePaidCalendarSelectors = () => {
  const dispatch = useDispatch()

  const selectedDate = useTypedSelector(state =>
    optInSelectors.getPaidBookingFieldValue(state.optIn, 'date'),
  )
  const selectedTimeSlot = useTypedSelector(state =>
    optInSelectors.getPaidBookingFieldValue(state.optIn, 'timeSlot'),
  )
  const selectedTimeZone = useTypedSelector(state =>
    optInSelectors.getPaidBookingFieldValue(state.optIn, 'timeZone'),
  )
  const selectedLocationId = useTypedSelector(state =>
    optInSelectors.getPaidBookingFieldValue(state.optIn, 'eventLocationId'),
  )

  const handleChangeField = <T>(slug: BookingFieldsSlug, value: T) => {
    dispatch(changePaidBookingField(slug, value))
  }

  return {
    selectedDate,
    selectedTimeSlot,
    selectedTimeZone,
    selectedLocationId,
    handleChangeField,
  }
}
